/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'

const LandingIndexLazyRouteImport = createFileRoute('/_landing/')()
const UnauthIndexLazyRouteImport = createFileRoute('/unauth/')()
const AuthAccountsIndexLazyRouteImport = createFileRoute('/_auth/accounts/')()
const AuthAccountsAccountIdLazyRouteImport = createFileRoute(
  '/_auth/accounts/$accountId',
)()
const AuthCommissionsIndexLazyRouteImport = createFileRoute(
  '/_auth/commissions/',
)()
const AuthConfigIndexLazyRouteImport = createFileRoute('/_auth/config/')()
const AuthDocumentsIndexLazyRouteImport = createFileRoute('/_auth/documents/')()
const AuthHomeIndexLazyRouteImport = createFileRoute('/_auth/home/')()
const AuthProgramsIndexLazyRouteImport = createFileRoute('/_auth/programs/')()
const AuthProgramsProgramIdLazyRouteImport = createFileRoute(
  '/_auth/programs/$programId',
)()
const AuthReportsAgentPerformanceLazyRouteImport = createFileRoute(
  '/_auth/reports/agent-performance',
)()
const AuthReportsRevenueLazyRouteImport = createFileRoute(
  '/_auth/reports/revenue',
)()

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingIndexLazyRoute = LandingIndexLazyRouteImport.update({
  id: '/_landing/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/_landing/index.lazy').then((d) => d.Route),
)
const UnauthIndexLazyRoute = UnauthIndexLazyRouteImport.update({
  id: '/unauth/',
  path: '/unauth/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/unauth/index.lazy').then((d) => d.Route))
const AuthAccountsIndexLazyRoute = AuthAccountsIndexLazyRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/accounts/index.lazy').then((d) => d.Route),
)
const AuthAccountsAccountIdLazyRoute =
  AuthAccountsAccountIdLazyRouteImport.update({
    id: '/accounts/$accountId',
    path: '/accounts/$accountId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/accounts/$accountId.lazy').then((d) => d.Route),
  )
const AuthCommissionsIndexLazyRoute =
  AuthCommissionsIndexLazyRouteImport.update({
    id: '/commissions/',
    path: '/commissions/',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/commissions/index.lazy').then((d) => d.Route),
  )
const AuthConfigIndexLazyRoute = AuthConfigIndexLazyRouteImport.update({
  id: '/config/',
  path: '/config/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/config/index.lazy').then((d) => d.Route),
)
const AuthDocumentsIndexLazyRoute = AuthDocumentsIndexLazyRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/documents/index.lazy').then((d) => d.Route),
)
const AuthHomeIndexLazyRoute = AuthHomeIndexLazyRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/home/index.lazy').then((d) => d.Route),
)
const AuthProgramsIndexLazyRoute = AuthProgramsIndexLazyRouteImport.update({
  id: '/programs/',
  path: '/programs/',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/programs/index.lazy').then((d) => d.Route),
)
const AuthProgramsProgramIdLazyRoute =
  AuthProgramsProgramIdLazyRouteImport.update({
    id: '/programs/$programId',
    path: '/programs/$programId',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/programs/$programId.lazy').then((d) => d.Route),
  )
const AuthReportsAgentPerformanceLazyRoute =
  AuthReportsAgentPerformanceLazyRouteImport.update({
    id: '/reports/agent-performance',
    path: '/reports/agent-performance',
    getParentRoute: () => AuthRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/reports/agent-performance.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthReportsRevenueLazyRoute = AuthReportsRevenueLazyRouteImport.update({
  id: '/reports/revenue',
  path: '/reports/revenue',
  getParentRoute: () => AuthRouteRoute,
} as any).lazy(() =>
  import('./routes/_auth/reports/revenue.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof LandingIndexLazyRoute
  '/unauth/': typeof UnauthIndexLazyRoute
  '/accounts/$accountId': typeof AuthAccountsAccountIdLazyRoute
  '/programs/$programId': typeof AuthProgramsProgramIdLazyRoute
  '/reports/agent-performance': typeof AuthReportsAgentPerformanceLazyRoute
  '/reports/revenue': typeof AuthReportsRevenueLazyRoute
  '/accounts/': typeof AuthAccountsIndexLazyRoute
  '/commissions/': typeof AuthCommissionsIndexLazyRoute
  '/config/': typeof AuthConfigIndexLazyRoute
  '/documents/': typeof AuthDocumentsIndexLazyRoute
  '/home/': typeof AuthHomeIndexLazyRoute
  '/programs/': typeof AuthProgramsIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof LandingIndexLazyRoute
  '/unauth': typeof UnauthIndexLazyRoute
  '/accounts/$accountId': typeof AuthAccountsAccountIdLazyRoute
  '/programs/$programId': typeof AuthProgramsProgramIdLazyRoute
  '/reports/agent-performance': typeof AuthReportsAgentPerformanceLazyRoute
  '/reports/revenue': typeof AuthReportsRevenueLazyRoute
  '/accounts': typeof AuthAccountsIndexLazyRoute
  '/commissions': typeof AuthCommissionsIndexLazyRoute
  '/config': typeof AuthConfigIndexLazyRoute
  '/documents': typeof AuthDocumentsIndexLazyRoute
  '/home': typeof AuthHomeIndexLazyRoute
  '/programs': typeof AuthProgramsIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_landing/': typeof LandingIndexLazyRoute
  '/unauth/': typeof UnauthIndexLazyRoute
  '/_auth/accounts/$accountId': typeof AuthAccountsAccountIdLazyRoute
  '/_auth/programs/$programId': typeof AuthProgramsProgramIdLazyRoute
  '/_auth/reports/agent-performance': typeof AuthReportsAgentPerformanceLazyRoute
  '/_auth/reports/revenue': typeof AuthReportsRevenueLazyRoute
  '/_auth/accounts/': typeof AuthAccountsIndexLazyRoute
  '/_auth/commissions/': typeof AuthCommissionsIndexLazyRoute
  '/_auth/config/': typeof AuthConfigIndexLazyRoute
  '/_auth/documents/': typeof AuthDocumentsIndexLazyRoute
  '/_auth/home/': typeof AuthHomeIndexLazyRoute
  '/_auth/programs/': typeof AuthProgramsIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/unauth/'
    | '/accounts/$accountId'
    | '/programs/$programId'
    | '/reports/agent-performance'
    | '/reports/revenue'
    | '/accounts/'
    | '/commissions/'
    | '/config/'
    | '/documents/'
    | '/home/'
    | '/programs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/unauth'
    | '/accounts/$accountId'
    | '/programs/$programId'
    | '/reports/agent-performance'
    | '/reports/revenue'
    | '/accounts'
    | '/commissions'
    | '/config'
    | '/documents'
    | '/home'
    | '/programs'
  id:
    | '__root__'
    | '/_auth'
    | '/_landing/'
    | '/unauth/'
    | '/_auth/accounts/$accountId'
    | '/_auth/programs/$programId'
    | '/_auth/reports/agent-performance'
    | '/_auth/reports/revenue'
    | '/_auth/accounts/'
    | '/_auth/commissions/'
    | '/_auth/config/'
    | '/_auth/documents/'
    | '/_auth/home/'
    | '/_auth/programs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  LandingIndexLazyRoute: typeof LandingIndexLazyRoute
  UnauthIndexLazyRoute: typeof UnauthIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_landing/': {
      id: '/_landing/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LandingIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauth/': {
      id: '/unauth/'
      path: '/unauth'
      fullPath: '/unauth/'
      preLoaderRoute: typeof UnauthIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/accounts/': {
      id: '/_auth/accounts/'
      path: '/accounts'
      fullPath: '/accounts/'
      preLoaderRoute: typeof AuthAccountsIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/accounts/$accountId': {
      id: '/_auth/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/accounts/$accountId'
      preLoaderRoute: typeof AuthAccountsAccountIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/commissions/': {
      id: '/_auth/commissions/'
      path: '/commissions'
      fullPath: '/commissions/'
      preLoaderRoute: typeof AuthCommissionsIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/config/': {
      id: '/_auth/config/'
      path: '/config'
      fullPath: '/config/'
      preLoaderRoute: typeof AuthConfigIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/documents/': {
      id: '/_auth/documents/'
      path: '/documents'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthDocumentsIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/home/': {
      id: '/_auth/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof AuthHomeIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/programs/': {
      id: '/_auth/programs/'
      path: '/programs'
      fullPath: '/programs/'
      preLoaderRoute: typeof AuthProgramsIndexLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/programs/$programId': {
      id: '/_auth/programs/$programId'
      path: '/programs/$programId'
      fullPath: '/programs/$programId'
      preLoaderRoute: typeof AuthProgramsProgramIdLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/reports/agent-performance': {
      id: '/_auth/reports/agent-performance'
      path: '/reports/agent-performance'
      fullPath: '/reports/agent-performance'
      preLoaderRoute: typeof AuthReportsAgentPerformanceLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/reports/revenue': {
      id: '/_auth/reports/revenue'
      path: '/reports/revenue'
      fullPath: '/reports/revenue'
      preLoaderRoute: typeof AuthReportsRevenueLazyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthAccountsAccountIdLazyRoute: typeof AuthAccountsAccountIdLazyRoute
  AuthProgramsProgramIdLazyRoute: typeof AuthProgramsProgramIdLazyRoute
  AuthReportsAgentPerformanceLazyRoute: typeof AuthReportsAgentPerformanceLazyRoute
  AuthReportsRevenueLazyRoute: typeof AuthReportsRevenueLazyRoute
  AuthAccountsIndexLazyRoute: typeof AuthAccountsIndexLazyRoute
  AuthCommissionsIndexLazyRoute: typeof AuthCommissionsIndexLazyRoute
  AuthConfigIndexLazyRoute: typeof AuthConfigIndexLazyRoute
  AuthDocumentsIndexLazyRoute: typeof AuthDocumentsIndexLazyRoute
  AuthHomeIndexLazyRoute: typeof AuthHomeIndexLazyRoute
  AuthProgramsIndexLazyRoute: typeof AuthProgramsIndexLazyRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAccountsAccountIdLazyRoute: AuthAccountsAccountIdLazyRoute,
  AuthProgramsProgramIdLazyRoute: AuthProgramsProgramIdLazyRoute,
  AuthReportsAgentPerformanceLazyRoute: AuthReportsAgentPerformanceLazyRoute,
  AuthReportsRevenueLazyRoute: AuthReportsRevenueLazyRoute,
  AuthAccountsIndexLazyRoute: AuthAccountsIndexLazyRoute,
  AuthCommissionsIndexLazyRoute: AuthCommissionsIndexLazyRoute,
  AuthConfigIndexLazyRoute: AuthConfigIndexLazyRoute,
  AuthDocumentsIndexLazyRoute: AuthDocumentsIndexLazyRoute,
  AuthHomeIndexLazyRoute: AuthHomeIndexLazyRoute,
  AuthProgramsIndexLazyRoute: AuthProgramsIndexLazyRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  LandingIndexLazyRoute: LandingIndexLazyRoute,
  UnauthIndexLazyRoute: UnauthIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
